import React from 'react';

import GeneralProfile from '_components/organisms/GeneralProfile';

export default function ProfileSettings() {
  return (
    <div className="profile-settings">
      <GeneralProfile />
    </div>
  );
}
